<template>
  <div style="width: 100%">
    <div class="versionDatetimeJumps">
      <ul class="versionDatetimeJump">
        <li
          class="versionDatetimeJump__item"
          @click="subtract('year')"
        >
          1år
        </li>
        <li
          class="versionDatetimeJump__item"
          @click="subtract('month')"
        >
          1m
        </li>
        <li
          class="versionDatetimeJump__item"
          @click="subtract('day')"
        >
          1d
        </li>
        <li
          class="versionDatetimeJump__item"
          @click="subtract('hour')"
        >
          1t
        </li>
      </ul>
      <ul class="versionDatetimeJump">
        <li
          class="versionDatetimeJump__item"
          @click="now"
        >
          NU
        </li>
      </ul>
      <ul class="versionDatetimeJump">
        <li
          class="versionDatetimeJump__item"
          @click.prevent="add('hour')"
        >
          1t
        </li>
        <li
          class="versionDatetimeJump__item"
          @click.prevent="add('day')"
        >
          1d
        </li>
        <li
          class="versionDatetimeJump__item"
          @click.prevent="add('month')"
        >
          1m
        </li>
        <li
          class="versionDatetimeJump__item"
          @click.prevent="add('year')"
        >
          1år
        </li>
      </ul>
    </div>
    <slot />
  </div>
</template>

<script>
export default {
    name: 'Datejump',
    props: {
        value: { type: String, required: true },
    },
    computed: {
        date: {
            get() {
                return this.value;
            },
            set(newValue) {
                this.$emit('input', newValue);
            },
        },
    },
    methods: {
        now() {
            this.date = window.moment().toISOString();
        },
        add(type) {
            this.date = window.moment(this.date).add('1', type).startOf(type).toISOString();
        },
        subtract(type) {
            if (type === 'hour') {
                const t = window.moment(this.date).startOf(type);
                if (window.moment(t).isSame(window.moment(this.date))) {
                    this.date = window.moment(this.date).subtract('1', 'hour').startOf('hour').toISOString();
                } else {
                    this.date = window.moment(this.date).startOf('hour').toISOString();
                }
                return;
            }

            const current = window.moment(this.date).startOf(type);
            if (window.moment(current).isSame(window.moment(this.date))) {
                this.date = window.moment(this.date).subtract('1', type).startOf(type).toISOString();
            } else {
                this.date = window.moment(this.date).startOf(type).toISOString();
            }
        },
    },
};
</script>
